import { Tag } from 'antd';
import type { AlertView } from '../alerts.api';
import { alertAnsweredLine } from '../policies/alert-answered-line';
import { ALERT_STATUS_LABELS, STATUS_TAG_COLOURS } from '../policies/alert-labels';

/**
 * The status, an "Escalated" tag when nobody answered it in time, and who answered it. Stacked and narrow: this column sits beside the
 * action buttons, and a wider one pushes them off the right edge of the table at 1440px.
 */
export function AlertStatusCell({ alert }: { alert: AlertView }) {
  const answeredLine = alertAnsweredLine(alert);
  return (
    <div className="flex max-w-28 flex-col items-start gap-1">
      <Tag className="me-0" color={STATUS_TAG_COLOURS[alert.status]}>
        {ALERT_STATUS_LABELS[alert.status]}
      </Tag>
      {alert.escalatedAt && (
        <Tag className="me-0" color="warning" title={`Unanswered, escalated ${new Date(alert.escalatedAt).toLocaleString()}`}>
          Escalated
        </Tag>
      )}
      {answeredLine && <span className="text-xs text-muted">{answeredLine}</span>}
    </div>
  );
}
